import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import config from '~/config';

const AIHeader = withI18next()(() => (
  <div className="ai-header">
    <img
      className="ai-header-photo"
      src={`${config.staticPrefix}/static/assets/ai-genface/header_ai_genface.jpg`}
    />
    <style jsx>
      {`
        .ai-header-photo {
          width: calc(100% + 4px);
          height: auto;
          margin-left: -4px;
        }
      `}
    </style>
  </div>
));

export default AIHeader;
